import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { AUTH_TOKEN } from "constants/AuthConstant";
import ApkLoanInsuranceKKBService from "services/Setup/LoanOrigination/ApkLoanInsuranceKKB/ApkLoanInsuranceKKBService";
import { notification } from "antd";

export const initialState = {
  loading: false,
  loadingAddInsurance: false,
  message: "",
  showMessage: false,
  redirect: "",
  token: localStorage.getItem(AUTH_TOKEN) || null,
  result: {},
  productList: {},
  refreshList: false,
  getPageSize: "",
  getPageIndex: "",
  getCount: "",
  loanInsuranceItem: [],
  EditloanInsuranceItem: [],
  sellingRateItem: [],
  plansList: [],
  opsiPerluasan: [],
  calculatePremiList: [],
  lifeInsuranceList: [],
  creditInsuranceList: [],
  statusRespon: 0,
  loadingSellingRate: false, // ganti nama lebih jelas
  savedInsuranceData: null,
};

export const getAddSlice = createAsyncThunk(
  "apkLoanInsuranceKKB/getAddSlice",
  async (prospectid, { rejectWithValue }) => {
    try {
      const response = await ApkLoanInsuranceKKBService.getAddService(
        prospectid
      );
      if (response.status === 200 && response.data) {
        return response.data;
      } else {
        notification.error({
          message: "Error",
          description: response?.data?.message || "Unexpected response!",
          duration: 3,
        });
        return rejectWithValue(
          response?.data?.message || "Unexpected response!"
        );
      }
    } catch (error) {
      notification.error({
        message: error?.response?.status || "Error",
        description: error?.response?.statusText || "Unexpected error",
        duration: 3,
      });
      return rejectWithValue(
        error?.response?.data?.message || "Unexpected error"
      );
    }
  }
);

export const getEditSlice = createAsyncThunk(
  "apkLoanInsuranceKKB/getEditSlice",
  async (prospectid, { rejectWithValue }) => {
    try {
      const response = await ApkLoanInsuranceKKBService.getEditService(
        prospectid
      );
      if (response.status === 200 && response.data) {
        return response.data;
      } else {
        notification.error({
          message: "Error",
          description: response?.data?.message || "Unexpected response!",
          duration: 3,
        });
        return rejectWithValue(
          response?.data?.message || "Unexpected response!"
        );
      }
    } catch (error) {
      notification.error({
        message: error?.response?.status || "Error",
        description: error?.response?.statusText || "Unexpected error",
        duration: 3,
      });
      return rejectWithValue(
        error?.response?.data?.message || "Unexpected error"
      );
    }
  }
);

export const sellingRateSlice = createAsyncThunk(
  "apkLoanInsuranceKKB/sellingRateSlice",
  async (prospectid, { rejectWithValue }) => {
    try {
      const response = await ApkLoanInsuranceKKBService.getSellingRateService(
        prospectid
      );
      if (response.status === 200 && response.data) {
        return response.data;
      } else {
        notification.error({
          message: "Error",
          description: response?.data?.message || "Unexpected response!",
          duration: 3,
        });
        return rejectWithValue(
          response?.data?.message || "Unexpected response!"
        );
      }
    } catch (error) {
      // notification.error({
      //   message: error?.response?.status || "Error",
      //   description: error?.response?.statusText || "Unexpected error",
      //   duration: 3,
      // });
      return rejectWithValue(
        error?.response?.data?.message || "Unexpected error"
      );
    }
  }
);

export const getPlansSlice = createAsyncThunk(
  "apkLoanInsuranceKKB/getPlansSlice",
  async (prospectid, { rejectWithValue }) => {
    try {
      const response = await ApkLoanInsuranceKKBService.getPlansService(
        prospectid
      );
      if (response.status === 200 && response.data) {
        return response.data;
      } else {
        notification.error({
          message: "Error",
          description: response?.data?.message || "Unexpected response!",
          duration: 3,
        });
        return rejectWithValue(
          response?.data?.message || "Unexpected response!"
        );
      }
    } catch (error) {
      notification.error({
        message: error?.response?.status || "Error",
        description: error?.response?.statusText || "Unexpected error",
        duration: 3,
      });
      return rejectWithValue(
        error?.response?.data?.message || "Unexpected error"
      );
    }
  }
);

export const opsiPerluasanSlice = createAsyncThunk(
  "APKFAS1Slices/opsiPerluasanSlice",
  async (userInput, { rejectWithValue }) => {

    try {
      const response = await ApkLoanInsuranceKKBService.opsiPerluasanServer(
        userInput
      );

      if (response.status === 200) {
        return response.data;
      } else {
        notification.error({
          message: "Error",
          description: response?.data?.message || "Unexpected response!",
          duration: 3,
        });
        return rejectWithValue(response?.data?.message || "Unexpected response!");
      }
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Unexpected response!"
      );
    }
  }
);

export const calculatePremiSlice = createAsyncThunk(
  "APKFAS1Slices/calculatePremiSlice",
  async (userInput, { rejectWithValue }) => {
    try {
      const response = await ApkLoanInsuranceKKBService.calculatePremiService(
        userInput
      );

      if (response.status === 200) {
        notification.success({
          message: response.data.status || "Success",
          description: response.data.message,
          duration: 3,
        });
        return response.data;
      } else {
        notification.error({
          message: "Error",
          description: response?.data?.message || "Unexpected response!",
          duration: 3,
        });
        return rejectWithValue(response?.data?.message || "Unexpected response!");
      }
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Unexpected response!"
      );
    }
  }
);

export const getLifeInsuranceSlice = createAsyncThunk(
  "apkLoanInsuranceKKB/getLifeInsuranceSlice",
  async (data, { rejectWithValue }) => {
    try {
      const response = await ApkLoanInsuranceKKBService.getLifeInsuranceService(
        data
      );
      if (response.status === 200 && response.data) {
        return response.data;
      } else {
        notification.error({
          message: "Error",
          description: response?.data?.message || "Unexpected response!",
          duration: 3,
        });
        return rejectWithValue(
          response?.data?.message || "Unexpected response!"
        );
      }
    } catch (error) {
      notification.error({
        message: error?.response?.status || "Error",
        description: error?.response?.statusText || "Unexpected error",
        duration: 3,
      });
      return rejectWithValue(
        error?.response?.data?.message || "Unexpected error"
      );
    }
  }
);

export const getCreditInsuranceSlice = createAsyncThunk(
  "apkLoanInsuranceKKB/getCreditInsuranceSlice",
  async (data, { rejectWithValue }) => {
    try {
      const response =
        await ApkLoanInsuranceKKBService.getCreditInsuranceService(data);
      if (response.status === 200 && response.data) {
        return response.data;
      } else {
        notification.error({
          message: "Error",
          description: response?.data?.message || "Unexpected response!",
          duration: 3,
        });
        return rejectWithValue(
          response?.data?.message || "Unexpected response!"
        );
      }
    } catch (error) {
      notification.error({
        message: error?.response?.status || "Error",
        description: error?.response?.statusText || "Unexpected error",
        duration: 3,
      });
      return rejectWithValue(
        error?.response?.data?.message || "Unexpected error"
      );
    }
  }
);

export const postAddInsuranceSlice = createAsyncThunk(
  "APKFAS1Slices/postAddInsuranceSlice",
  async (userInput, { rejectWithValue }) => {
    try {
      const response = await ApkLoanInsuranceKKBService.postAddInsuranceService(
        userInput
      );

      if (response.status === 200) {
        if (response.data.status === "Success") {
          notification.success({
            message: response.data.status || "Success",
            description: response.data.message,
            duration: 3,
          });
          return response.data;
        } else {
          notification.error({
            message: response.data.status || "Failed",
            description: response.data.message || "Terjadi kesalahan.",
            duration: 5,
          });
          return rejectWithValue(response.data.message);
        }
      } else {
        notification.error({
          message: "Error",
          description: response?.data?.message || "Unexpected response!",
          duration: 5,
        });
        return rejectWithValue(response?.data?.message || "Unexpected response!");
      }
    } catch (error) {
      const msg =
        error?.response?.data?.message ||
        error?.response?.statusText ||
        "Unexpected error";
      notification.error({
        message: error?.response?.status || "Error",
        description: msg,
        duration: 5,
      });
      return rejectWithValue(msg);
    }
  }
);

export const ApkLoanInsuranceKKB = createSlice({
  name: "apkLoanInsuranceKKB",
  initialState,
  reducers: {
    showNotification: (state, action) => {
      state.message = action.payload;
      state.showMessage = true;
      state.loading = false;
    },
    hideNotification: (state) => {
      state.message = "";
      state.showMessage = false;
    },
    showLoading: (state) => {
      state.loading = true;
    },
    resetStatusRespon: (state) => {
      state.statusRespon = 0;
    },
    setcreditStepKTA: (state, action) => {
      state.creditStepKTA = action.payload;
    },
    setSavedInsuranceData: (state, action) => {
      state.savedInsuranceData = action.payload;
    },
    clearSavedInsuranceData: (state) => {
      state.savedInsuranceData = null;
    },
    resetCalculatePremi: (state) => {
      state.calculatePremiList = [];
    },
  },
  extraReducers: (builder) => {
    // getAddSlice
    builder
      .addCase(getAddSlice.pending, (state) => {
        state.loading = true;
        state.redirect = "";
      })
      .addCase(getAddSlice.fulfilled, (state, action) => {
        state.loading = false;
        state.loanInsuranceItem = action.payload.data || [];
        state.getCount = action.payload.count || 0;
      })
      .addCase(getAddSlice.rejected, (state) => {
        state.loading = false;
      })
      // getEditSlice
      .addCase(getEditSlice.pending, (state) => {
        state.loading = true;
        state.redirect = "";
      })
      .addCase(getEditSlice.fulfilled, (state, action) => {
        state.loading = false;
        state.EditloanInsuranceItem = action.payload.data || [];
        state.getCount = action.payload.count || 0;
      })
      .addCase(getEditSlice.rejected, (state) => {
        state.loading = false;
      })
      // sellingRateSlice
      .addCase(sellingRateSlice.pending, (state) => {
        state.loadingSellingRate = true;
      })
      .addCase(sellingRateSlice.fulfilled, (state, action) => {
        // console.log("sellingRateSlice fulfilled", action.payload);

        state.loadingSellingRate = false;
        state.sellingRateItem = action.payload;
        state.showMessage = true;
        state.message = action.payload?.message;
        state.statusRespon = "Success";
      })
      .addCase(sellingRateSlice.rejected, (state, action) => {
        state.loadingSellingRate = false;
        state.sellingRateItem = "Error";
        state.showMessage = true;
        state.statusRespon = "Error";
      })
      // getPlansSlice
      .addCase(getPlansSlice.pending, (state) => {
        state.loadingSellingRate = true;
      })
      .addCase(getPlansSlice.fulfilled, (state, action) => {
        // console.log("getPlansSlice fulfilled", action.payload);

        state.loadingSellingRate = false;
        state.plansList = action.payload;
        state.showMessage = true;
        state.message = action.payload?.message;
        state.statusRespon = "Success";
      })
      .addCase(getPlansSlice.rejected, (state, action) => {
        state.loadingSellingRate = false;
        state.sellingRateItem = "Error";
        state.showMessage = true;
        state.statusRespon = "Error";
      })
      // opsiPerluasanSlice
      .addCase(opsiPerluasanSlice.pending, (state) => {
        state.loadingSellingRate = true;
      })
      .addCase(opsiPerluasanSlice.fulfilled, (state, action) => {
        // console.log("opsiPerluasanSlice fulfilled", action.payload);

        state.loadingSellingRate = false;
        state.opsiPerluasan = action.payload;
        state.showMessage = true;
        state.message = action.payload?.message;
        state.statusRespon = "Success";
      })
      .addCase(opsiPerluasanSlice.rejected, (state, action) => {
        state.loadingSellingRate = false;
        state.sellingRateItem = "Error";
        state.showMessage = true;
        state.statusRespon = "Error";
      })
      // calculatePremiSlice
      .addCase(calculatePremiSlice.pending, (state) => {
        state.loadingSellingRate = true;
      })
      .addCase(calculatePremiSlice.fulfilled, (state, action) => {
        // console.log("calculatePremiSlice fulfilled", action.payload);

        state.loadingSellingRate = false;
        state.calculatePremiList = action.payload;
        state.showMessage = true;
        state.message = action.payload?.message;
        state.statusRespon = "Success";
      })
      .addCase(calculatePremiSlice.rejected, (state, action) => {
        state.loadingSellingRate = false;
        state.sellingRateItem = "Error";
        state.showMessage = true;
        state.statusRespon = "Error";
      })
      .addCase(getLifeInsuranceSlice.pending, (state) => {
        state.loadingSellingRate = true;
      })
      .addCase(getLifeInsuranceSlice.fulfilled, (state, action) => {
        // console.log("getLifeInsuranceSlice fulfilled", action.payload);

        state.loadingSellingRate = false;
        state.lifeInsuranceList = action.payload;
        state.showMessage = true;
        state.message = action.payload?.message;
        state.statusRespon = "Success";
      })
      .addCase(getLifeInsuranceSlice.rejected, (state, action) => {
        state.loadingSellingRate = false;
        state.sellingRateItem = "Error";
        state.showMessage = true;
        state.statusRespon = "Error";
      })

      .addCase(getCreditInsuranceSlice.pending, (state) => {
        state.loadingSellingRate = true;
      })
      .addCase(getCreditInsuranceSlice.fulfilled, (state, action) => {
        // console.log("getCreditInsuranceSlice fulfilled", action.payload);

        state.loadingSellingRate = false;
        state.creditInsuranceList = action.payload;
        state.showMessage = true;
        state.message = action.payload?.message;
        state.statusRespon = "Success";
      })
      .addCase(getCreditInsuranceSlice.rejected, (state, action) => {
        state.loadingSellingRate = false;
        state.sellingRateItem = "Error";
        state.showMessage = true;
        state.statusRespon = "Error";
      })

      // postAddInsuranceSlice
      .addCase(postAddInsuranceSlice.pending, (state) => {
        state.loadingAddInsurance = true;
      })
      .addCase(postAddInsuranceSlice.fulfilled, (state, action) => {
        // console.log("postAddInsuranceSlice fulfilled", action.payload);

        state.loadingAddInsurance = false;
        // state.calculatePremiList = action.payload;
        state.showMessage = true;
        state.message = action.payload?.message;
        state.statusRespon = "Success";
      })
      .addCase(postAddInsuranceSlice.rejected, (state, action) => {
        state.loadingAddInsurance = false;
        state.sellingRateItem = "Error";
        state.showMessage = true;
        state.statusRespon = "Error";
      });
  },
});

export const {
  showNotification,
  hideNotification,
  showLoading,
  resetStatusRespon,
  setcreditStepKTA,
  setSavedInsuranceData,
  clearSavedInsuranceData,
  resetCalculatePremi,
} = ApkLoanInsuranceKKB.actions;

export default ApkLoanInsuranceKKB.reducer;
